import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';
import AboutSection from './AboutSection';
import KeyHighlightsSection from './KeyHighlightsSection';
import {
  SITE_ORIGIN,
  OG_SHARE_IMAGE_URL,
  OG_SHARE_IMAGE_WIDTH,
  OG_SHARE_IMAGE_HEIGHT,
  SITE_BRAND_NAME,
  SITE_BRAND_LEGACY,
  SITE_BRAND_TAGLINE_SEO
} from '../constants/siteBranding';
import './AboutPage.css';

const CANONICAL = `${SITE_ORIGIN}/about`;
const ABOUT_TITLE = `About ${SITE_BRAND_NAME} | Ahmedabad`;
const ABOUT_DESCRIPTION = `${SITE_BRAND_TAGLINE_SEO} Learn about our team, values, and facility support for offices, malls, hospitals and societies. Formerly ${SITE_BRAND_LEGACY}.`;

function AboutPage() {
  return (
    <div className="about-page">
      <Helmet>
        <title>{ABOUT_TITLE}</title>
        <meta name="description" content={ABOUT_DESCRIPTION} />
        <meta
          name="keywords"
          content={`${SITE_BRAND_NAME} about, facility management company Ahmedabad, housekeeping agency Ahmedabad history, ${SITE_BRAND_LEGACY}`}
        />
        <link rel="canonical" href={CANONICAL} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={CANONICAL} />
        <meta property="og:title" content={ABOUT_TITLE} />
        <meta property="og:description" content={ABOUT_DESCRIPTION} />
        <meta property="og:image" content={OG_SHARE_IMAGE_URL} />
        <meta property="og:image:width" content={String(OG_SHARE_IMAGE_WIDTH)} />
        <meta property="og:image:height" content={String(OG_SHARE_IMAGE_HEIGHT)} />
        <meta property="og:site_name" content={SITE_BRAND_NAME} />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={ABOUT_TITLE} />
        <meta name="twitter:description" content={ABOUT_DESCRIPTION} />
        <meta name="twitter:image" content={OG_SHARE_IMAGE_URL} />
      </Helmet>
      <Header />
      <main className="about-page-main">
        <AboutSection />
        <KeyHighlightsSection />
      </main>
      <Footer />
    </div>
  );
}

export default AboutPage;
